@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (upcomingTransactions.length === 0 && !loading) {
  <mat-card>
    <mat-card-content>
      <div class="empty-table">
        <mat-icon>info</mat-icon>
        <p>No upcoming transactions found</p>
      </div>
    </mat-card-content>
  </mat-card>
}

@if (upcomingTransactions.length > 0 && !loading) {
  <div class="table-container">
    <table mat-table [dataSource]="upcomingTransactions" class="transactions-table">
      <!-- Transaction ID Column -->
      <ng-container matColumnDef="transaction_id">
        <th mat-header-cell *matHeaderCellDef>Transaction ID</th>
        <td mat-cell *matCellDef="let transaction">
          <a [routerLink]="['/', transactionDetailsLink, transaction.transaction_id]" class="button-link">
            {{ transaction.transaction_id }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="supplier_company">
        <th mat-header-cell *matHeaderCellDef>Supplier</th>
        <td mat-cell *matCellDef="let transaction">{{ transaction.supplier_company }}</td>
      </ng-container>

      <ng-container matColumnDef="purchase_date">
        <th mat-header-cell *matHeaderCellDef>Purchase Date</th>
        <td mat-cell *matCellDef="let transaction">{{ transaction.origination_date }}</td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let transaction">{{ formatCurrency(transaction.amount) }}</td>
      </ng-container>

      <ng-container matColumnDef="current_balance">
        <th mat-header-cell *matHeaderCellDef>Current Balance</th>
        <td mat-cell *matCellDef="let transaction">{{ formatCurrency(transaction.current_balance) }}</td>
      </ng-container>

      <ng-container matColumnDef="next_payment_due">
        <th mat-header-cell *matHeaderCellDef>Next Payment Due</th>
        <td mat-cell *matCellDef="let transaction">{{ transaction.next_payment_due | date:'shortDate' }}</td>
      </ng-container>

      <ng-container matColumnDef="next_payment_amount">
        <th mat-header-cell *matHeaderCellDef>Next Payment Amount</th>
        <td mat-cell *matCellDef="let transaction">{{ formatCurrency(transaction.next_payment_total_amount) }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let transaction">
          <button mat-raised-button color="primary" class="pay-now-button" (click)="onPayNow(transaction)">
            Pay Now
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="transaction-row"></tr>
    </table>
  </div>
}
